import React from 'react';
import { Check, Clock, Shield, BookOpen, Users, Zap, Award, Download, AlertCircle } from 'lucide-react';
import { MetaPixel } from '../components/MetaPixel';
import { PurchaseButton } from '../components/PurchaseButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { FAQItem } from '../components/FAQItem';
export function LandingPage() {
  const mainImage = 'https://cdn.magicpatterns.com/uploads/5LEPBYsLGbF7x4M2smNkhM/PROYECTOS_Anuales_(3).png';
  const bonus1Image = 'https://cdn.magicpatterns.com/uploads/v5nBe8R3tnax2qfW6nsUad/26.png';
  const bonus2Image = 'https://cdn.magicpatterns.com/uploads/wUuA4ncuVvctCKrn581Cxa/27.png';
  const bonus3Image = 'https://cdn.magicpatterns.com/uploads/rQNDfa56Y2XGGeZ8cUaec7/28.png';
  const bonus4Image = 'https://cdn.magicpatterns.com/uploads/srwiYh6piBLcJ97AZUiAuv/PROYECTOS_Anuales_(4).png';
  const testimonials = [{
    name: 'Laura Fernández',
    role: 'Profesora de Biología',
    location: 'Buenos Aires, Argentina',
    quote: 'Me devolvió el control de mi año docente. Ya no paso los domingos planificando.'
  }, {
    name: 'Carlos Méndez',
    role: 'Docente de Secundaria',
    location: 'Santiago, Chile',
    quote: 'Nunca tuve un material tan completo. Mis alumnos entienden mucho mejor y participan más.'
  }, {
    name: 'Ana García',
    role: 'Profesora de Ciencias',
    location: 'Madrid, España',
    quote: 'Mis clases cambiaron por completo. Ahora enseño con orden y tranquilidad.'
  }, {
    name: 'Roberto Silva',
    role: 'Profesor de Biología',
    location: 'Lima, Perú',
    quote: 'Las guías de laboratorio son espectaculares. Todo está listo para aplicar.'
  }, {
    name: 'María Torres',
    role: 'Docente de Ciencias',
    location: 'Ciudad de México, México',
    quote: 'Es la mejor inversión que hice este año. Todo listo para imprimir y usar.'
  }];
  const faqs = [{
    question: '¿El material es digital o físico?',
    answer: 'Es 100% digital. Recibís acceso inmediato a una plataforma donde podés descargar todo el material en formato PDF de alta calidad, listo para imprimir o usar en dispositivos.'
  }, {
    question: '¿Cómo recibo el MegaPack?',
    answer: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso a nuestra plataforma privada. Es automático y al instante.'
  }, {
    question: '¿Sirve para todos los niveles?',
    answer: 'Sí, el pack cubre contenidos desde 1° a 6° año de secundaria/bachillerato, con materiales adaptables a diferentes niveles de profundidad.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. El material está diseñado para ser intuitivo y fácil de aplicar, tanto si recién empezás como si tenés años de experiencia.'
  }, {
    question: '¿Puedo usarlo en clases presenciales y virtuales?',
    answer: 'Absolutamente. Los archivos digitales son perfectos para compartir en pantalla, enviar por campus virtual o imprimir para el aula.'
  }, {
    question: '¿Cuánto tiempo tengo acceso?',
    answer: 'El acceso es DE POR VIDA. Pagás una sola vez y el material es tuyo para siempre, incluyendo futuras actualizaciones.'
  }, {
    question: '¿Es seguro comprar?',
    answer: 'Totalmente. Usamos pasarelas de pago encriptadas de nivel bancario. Nosotros no almacenamos tus datos de tarjeta.'
  }, {
    question: '¿Qué pasa si no me sirve?',
    answer: 'Tenés nuestra garantía de 7 días. Si el material no cumple tus expectativas, nos escribís y te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-47">
      <MetaPixel data-id="element-48" />
      <PurchasePopup data-id="element-49" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-emerald-50 to-white pt-6 pb-8 px-4 border-b border-gray-100" data-id="element-50">
        <div className="max-w-4xl mx-auto text-center" data-id="element-51">
          <p className="text-emerald-700 font-bold tracking-wider uppercase mb-2 text-sm md:text-base" data-id="element-52">
            Para docentes de Biología
          </p>
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4" data-id="element-53">
            ORGANIZÁ TODO TU AÑO DE BIOLOGÍA{' '}
            <span className="text-emerald-600" data-id="element-54">SIN ESTRÉS</span>
          </h1>

          <div className="mb-4 flex justify-center" data-id="element-55">
            <img src={mainImage} alt="MegaPack Biología Lista - Colección Completa" className="w-full max-w-[300px] drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-56" />
          </div>

          <p className="text-xl md:text-2xl text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-57">
            Material listo para usar que te ahorra horas de preparación y te
            permite dar clases claras, prácticas y alineadas al programa
            escolar.
          </p>

          <PurchaseButton text="QUIERO ACCESO INMEDIATO" data-id="element-58" />
        </div>
      </header>

      {/* Agitation / Pain Points */}
      <section className="py-16 px-4 bg-white" data-id="element-59">
        <div className="max-w-3xl mx-auto" data-id="element-60">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" data-id="element-61">
            Si sos docente de Biología, esto te va a sonar muy familiar…
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed" data-id="element-62">
            <p data-id="element-63">
              Llegás a tu casa cansado/a… Sabés que tenés que planificar… Abrís
              la compu…{' '}
              <span className="font-bold text-red-500" data-id="element-64">
                Y empezás otra vez de cero.
              </span>
            </p>
            <p data-id="element-65">
              Buscando actividades. Buscando experiencias de laboratorio.
              Buscando evaluaciones. Buscando ejemplos que se entiendan.
              Buscando formas de explicar lo complejo sin complicarlo más.
            </p>
            <p className="italic border-l-4 border-green-500 pl-4 py-2 bg-green-50" data-id="element-66">
              Y el tiempo vuela. Y el cansancio crece. Y tu cabeza no para.
            </p>
            <p data-id="element-67">
              No porque no sepas enseñar. No porque no seas buen/a docente.{' '}
              <span className="font-bold" data-id="element-68">
                Sino porque estás intentando sostener todo el año sin un sistema
                que te sostenga a vos.
              </span>
            </p>
          </div>

          <div className="mt-16 bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-69">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-70">
              <AlertCircle className="text-red-500" data-id="element-71" />
              El problema real: hoy el sistema educativo te exige…
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-72">
              {['Planificar', 'Armar actividades', 'Preparar experiencias', 'Evaluar', 'Nivelar grupos', 'Preparar proyectos', 'Cumplir programas', 'Motivar alumnos', 'Registrar avances'].map(item => <div key={item} className="flex items-center gap-2 text-gray-700" data-id="element-73">
                  <div className="w-2 h-2 bg-red-400 rounded-full" data-id="element-74"></div>
                  {item}
                </div>)}
            </div>
            <p className="mt-6 text-center font-medium text-gray-900" data-id="element-75">
              …todo al mismo tiempo. Y nadie te dio un sistema que te ahorre ese
              trabajo.
            </p>
          </div>

          <div className="mt-12 text-center" data-id="element-76">
            <p className="text-xl text-gray-600 mb-6" data-id="element-77">
              Vivís improvisando, llevando trabajo a casa, corriendo detrás del
              programa y sintiendo que nunca terminás.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50" data-id="element-78">
        <div className="max-w-5xl mx-auto text-center" data-id="element-79">
          <span className="inline-block py-1 px-3 rounded-full bg-emerald-100 text-emerald-700 text-sm font-bold mb-6" data-id="element-80">
            LA SOLUCIÓN DEFINITIVA
          </span>
          <h2 className="text-4xl md:text-6xl font-black mb-8 text-gray-900" data-id="element-81">
            MEGAPACK BIOLOGÍA LISTA™
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-3xl mx-auto" data-id="element-82">
            Un sistema completo de materiales de Biología organizados por nivel
            para que nunca más tengas que empezar de cero.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12" data-id="element-83">
            {[{
            icon: Check,
            text: 'Todo listo'
          }, {
            icon: Shield,
            text: 'Todo probado'
          }, {
            icon: BookOpen,
            text: 'Todo ordenado'
          }, {
            icon: Zap,
            text: 'Todo usable'
          }].map((item, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-emerald-100 flex flex-col items-center gap-3" data-id="element-84">
                <item.icon className="w-8 h-8 text-emerald-600" data-id="element-85" />
                <span className="font-bold text-lg text-gray-900" data-id="element-86">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-20 px-4 bg-white" data-id="element-87">
        <div className="max-w-4xl mx-auto" data-id="element-88">
          <div className="text-center mb-16" data-id="element-89">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-90">
              ¿Qué incluye el pack?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-91">
              +600 páginas de material digital. Una biblioteca completa para
              todo tu año de Biología.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 items-center" data-id="element-92">
            <div className="order-2 md:order-1" data-id="element-93">
              <ul className="space-y-4" data-id="element-94">
                {['Guías de laboratorio listas', 'Teoría clara y secuenciada', 'Actividades prácticas', 'Evaluaciones y diagnósticos', 'Planillas docentes', 'Carpetas de campo', 'Proyectos anuales', 'Secuencias y planificaciones'].map((item, idx) => <li key={idx} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-95">
                    <div className="bg-emerald-100 p-1 rounded-full" data-id="element-96">
                      <Check className="w-5 h-5 text-emerald-600" data-id="element-97" />
                    </div>
                    <span className="font-medium text-gray-800" data-id="element-98">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8 p-4 bg-indigo-50 rounded-lg border border-indigo-100 text-center" data-id="element-99">
                <p className="text-indigo-800 font-bold" data-id="element-100">
                  Para todo el sistema educativo — TODOS LOS NIVELES
                </p>
              </div>
            </div>
            <div className="order-1 md:order-2 flex justify-center" data-id="element-101">
              <img src={mainImage} alt="Contenido del pack" className="w-full max-w-xs drop-shadow-xl" data-id="element-102" />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-103">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-104">
          {/* Student Benefits */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-105">
            <div className="flex items-center gap-3 mb-6" data-id="element-106">
              <Users className="w-8 h-8 text-blue-500" data-id="element-107" />
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-108">
                Qué van a lograr tus alumnos
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-109">
              {['Entender la Biología paso a paso', 'Participar más en clase', 'Aprender haciendo', 'Comprender procesos complejos', 'Relacionar la Biología con la vida real', 'Sentirse más seguros'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-110">
                  <Check className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" data-id="element-111" />
                  <span className="text-gray-700" data-id="element-112">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Teacher Benefits */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-emerald-200 ring-1 ring-emerald-100" data-id="element-113">
            <div className="flex items-center gap-3 mb-6" data-id="element-114">
              <Award className="w-8 h-8 text-emerald-600" data-id="element-115" />
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-116">
                Qué vas a lograr vos
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-117">
              {['Ahorrar horas todas las semanas', 'Dejar de improvisar', 'Tener respaldo profesional', 'Cubrir todo el programa', 'Dar clases más claras y dinámicas', 'Volver a disfrutar enseñar'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-118">
                  <Check className="w-5 h-5 text-emerald-600 mt-1 flex-shrink-0" data-id="element-119" />
                  <span className="text-gray-700 font-medium" data-id="element-120">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-121">
          <PurchaseButton text="QUIERO LOGRAR ESTO" data-id="element-122" />
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-white" data-id="element-123">
        <div className="max-w-5xl mx-auto" data-id="element-124">
          <div className="text-center mb-16" data-id="element-125">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-126">
              BONOS EXTRA INCLUIDOS
            </h2>
            <p className="text-xl text-emerald-600 font-bold tracking-wide" data-id="element-127">
              GRATIS HOY CON TU COMPRA
            </p>
          </div>

          <div className="space-y-8" data-id="element-128">
            <BonusCard number={1} title="Biología Experimental" subtitle="+30 experiencias y actividades prácticas" description="Listas para aplicar desde la semana 1. Experiencias de laboratorio y aula que funcionan y atrapan a los alumnos." imageSrc={bonus1Image} data-id="element-129" />

            <BonusCard number={2} title="Kit de Evaluaciones por Año" subtitle="18 evaluaciones con criterios y rúbricas" description="Evaluaciones listas para 1° a 6°. Incluye criterios de corrección claros y rúbricas profesionales para ahorrarte tiempo corrigiendo." imageSrc={bonus2Image} data-id="element-130" />

            <BonusCard number={3} title="Material Didáctico Complementario" subtitle="Recursos visuales y teóricos extra" description="Genética, diversidad, metabolismo, ambiente y más. Láminas, esquemas y resúmenes para apoyar tus explicaciones." imageSrc={bonus3Image} data-id="element-131" />

            <BonusCard number={4} title="Planillas de Seguimiento y Planificación" subtitle="Tu organización docente resuelta" description="Modelos semanales y mensuales listos para organizarte y evaluar sin improvisar. Llevá el control de tus cursos fácilmente." imageSrc={bonus4Image} data-id="element-132" />
          </div>
        </div>
      </section>

      {/* Pricing / Offer Section */}
      <section id="compra" className="py-20 px-4 bg-gradient-to-br from-slate-50 via-gray-50 to-stone-50 relative overflow-hidden" data-id="element-133">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-134">
          <div className="absolute top-10 left-10 w-64 h-64 bg-emerald-400 rounded-full blur-3xl" data-id="element-135"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-teal-400 rounded-full blur-3xl" data-id="element-136"></div>
        </div>

        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-137">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-gray-900" data-id="element-138">
            ACCESO COMPLETO DE POR VIDA
          </h2>
          <p className="text-xl text-gray-600 mb-12" data-id="element-139">
            Todo el material + Todos los bonos
          </p>

          <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300 border border-gray-200" data-id="element-140">
            <div className="flex justify-center items-center gap-4 mb-6" data-id="element-141">
              <span className="text-gray-400 line-through text-2xl" data-id="element-142">
                $49.99 USD
              </span>
              <span className="bg-red-100 text-red-600 font-bold px-3 py-1 rounded-full text-sm" data-id="element-143">
                75% OFF
              </span>
            </div>

            <div className="text-6xl md:text-7xl font-black text-emerald-600 mb-4 tracking-tight" data-id="element-144">
              $13.99{' '}
              <span className="text-2xl text-gray-500 font-normal" data-id="element-145">USD</span>
            </div>

            <p className="text-sm text-gray-500 mb-8" data-id="element-146">
              *Pagarás en la moneda de tu país
            </p>

            <ul className="text-left space-y-3 mb-8 max-w-xs mx-auto" data-id="element-147">
              <li className="flex items-center gap-2" data-id="element-148">
                <Check className="w-5 h-5 text-emerald-500" data-id="element-149" />
                <span data-id="element-150">Acceso inmediato</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-151">
                <Check className="w-5 h-5 text-emerald-500" data-id="element-152" />
                <span data-id="element-153">Descarga ilimitada</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-154">
                <Check className="w-5 h-5 text-emerald-500" data-id="element-155" />
                <span data-id="element-156">Garantía de 7 días</span>
              </li>
            </ul>

            <PurchaseButton fullWidth={true} redirectToCheckout={true} data-id="element-157" />
          </div>

          <div className="mt-8 flex justify-center gap-4 text-gray-600 text-sm" data-id="element-158">
            <span className="flex items-center gap-1" data-id="element-159">
              <Shield size={14} data-id="element-160" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-161">
              <Download size={14} data-id="element-162" /> Entrega digital
            </span>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-163">
        <div className="max-w-6xl mx-auto" data-id="element-164">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-16" data-id="element-165">
            Lo que dicen otros docentes
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-166">
            {testimonials.map((t, idx) => <div key={idx} className={idx >= 3 ? 'md:col-span-1 md:last:col-start-2' : ''} data-id="element-167">
                <TestimonialCard {...t} data-id="element-168" />
              </div>)}
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-white" data-id="element-169">
        <div className="max-w-3xl mx-auto text-center border-2 border-dashed border-emerald-200 rounded-3xl p-8 md:p-12" data-id="element-170">
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-171">
            <Shield className="w-10 h-10 text-emerald-600" data-id="element-172" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-173">
            Garantía sin vueltas
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-174">
            Tenés 7 días para probarlo. Si no te sirve → te devolvemos el 100%
            del dinero. Asumimos todo el riesgo. Tu satisfacción es nuestra
            prioridad.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-175">
        <div className="max-w-3xl mx-auto" data-id="element-176">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-177">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-178">
            {faqs.map((faq, idx) => <FAQItem key={idx} {...faq} data-id="element-179" />)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-180">
        <div className="max-w-4xl mx-auto" data-id="element-181">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8" data-id="element-182">
            QUIERO EMPEZAR AHORA
          </h2>
          <div className="mb-10" data-id="element-183">
            <img src={mainImage} alt="MegaPack Biología Lista" className="w-64 mx-auto drop-shadow-2xl hover:scale-110 transition-transform duration-300" data-id="element-184" />
          </div>
          <PurchaseButton data-id="element-185" />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <p className="font-bold text-white text-lg mb-4" data-id="element-188">
            MEGAPACK BIOLOGÍA LISTA™
          </p>
          <p className="mb-6" data-id="element-189">Todos los derechos reservados © 2026</p>
          <div className="flex justify-center gap-6" data-id="element-190">
            <span className="hover:text-white cursor-pointer" data-id="element-191">Privacidad</span>
            <span className="hover:text-white cursor-pointer" data-id="element-192">Términos</span>
            <span className="hover:text-white cursor-pointer" data-id="element-193">Contacto</span>
          </div>
        </div>
      </footer>
    </div>;
}